
// 开发环境代理配置
const PROXY_DEV = {
    HTTP_APPLICATION_SERVER: "http://116.62.124.41:60221/console", // 全局http请求应用路径
    HTTP_AUTHORIZATION_SERVER_URL: "http://116.62.124.41:9999/oauth/token", // 全局http请求认证服务器路径
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://116.62.124.41:60221/console", // WEBSOCKET 请求应用路径
    TOKEN_URL:""
}

const PROXY_LOCAL = {
    HTTP_APPLICATION_SERVER: "http://192.168.1.236:60221/console", // 全局http请求应用路径
    HTTP_AUTHORIZATION_SERVER_URL: "http://116.62.124.41:9999/oauth/token", // 全局http请求认证服务器路径
    //HTTP_AUTHORIZATION_SERVER_URL: "http://192.168.1.236:9999/oauth/token", // 全局http请求认证服务器路径
    HTTP_APPLICATION_SERVER_VR: "http://a.ebike-charge.com:8888/area", // VR切换
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://192.168.1.236:60221/console", // WEBSOCKET 请求应用路径
    TOKEN_URL:""
};

// 测试环境代理配置
const PROXY_116 = {
    HTTP_APPLICATION_SERVER: "http://116.62.124.41:60221/console", // 全局http请求应用路径x
    HTTP_AUTHORIZATION_SERVER_URL: "http://116.62.124.41:9999/oauth/token", // 全局http请求认证服务器路径
    HTTP_YOLO_SERVER: "http://192.168.1.216:8080", // 全局http请求认证服务器路径
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://116.62.124.41:60221/console", // WEBSOCKET 请求应用路径
    TOKEN_URL:""
}

// 测试环境代理配置
const PROXY_TEST = {
    HTTP_APPLICATION_SERVER: "/console", // 全局http请求应用路径x
    HTTP_AUTHORIZATION_SERVER_URL: "/token", // 全局http请求认证服务器路径
    HTTP_APPLICATION_SERVER_VR: "/area", // VR切换
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://116.62.124.41:60221/console", // WEBSOCKET 请求应用路径
    TOKEN_URL:""
}

// 生产环境代理配置
const PROXY_PRODUCT = {
    HTTP_APPLICATION_SERVER: "/console", // 全局http请求应用路径x
    HTTP_AUTHORIZATION_SERVER_URL: "/token", // 全局http请求认证服务器路径
    HTTP_APPLICATION_SERVER_VR: "/area", // VR切换
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://47.97.163.5:60221/console", // WEBSOCKET 请求应用路径getContrastDataItemList
    //TOKEN_URL:".ebike-charge.com"----由于其他域需要访问我们网页，所以暂时去掉，如www.yggn365.com.cn
    TOKEN_URL:""
}

// 三叶草本地化系统配置
const PROXY_LOCALDB = {
    HTTP_APPLICATION_SERVER: "/console", // 全局http请求应用路径x
    HTTP_AUTHORIZATION_SERVER_URL: "/token", // 全局http请求认证服务器路径
    HTTP_APPLICATION_SERVER_VR: "/area", // VR切换
    CLIENT_BASIC_AUTH: "Basic aGFycnk6MTIzNDU2",  // 客户端basic认证
    WEBSOCKET_SERVER: "ws://10.22.126.200:60221/console", // WEBSOCKET 请求应用路径
    TOKEN_URL:""
}

// 导出开发或生产环境
export default PROXY_PRODUCT;
